import {createGate} from 'effector-react';
import {createEvent} from 'effector';

export const setApplicationsTableEv = createEvent()

export const ApplicationsGate = createGate()

export const selectApplicationEv = createEvent()
export const resetApplicationEv = createEvent()

export const submitAppUpdateEv = createEvent()

export const downloadAppFileEv = createEvent()